import {BrowserRouter, Route, Routes} from "react-router";
import {lazy, useMemo} from "react";
import type {User} from "@/api/model/user.ts";
import {RootContext} from "@/lib/contexts.ts";

const Backoffice = lazy(() => import("@/pages/backoffice.tsx"));
const UserManagement = lazy(() => import("@/pages/userManagement.tsx"));
const DryingUnitManagement = lazy(() => import("@/pages/dryingUnitManagement.tsx"));
const Layout = lazy(() => import("@/components/layout/layout.tsx"));
const Overview = lazy(() => import("@/pages/overview.tsx"));
const Control = lazy(() => import("@/pages/control.tsx"));
const Statistics = lazy(() => import("@/pages/statistics.tsx"));
const AlarmHistory = lazy(() => import("@/pages/alarmHistory.tsx"));

const PageNotFound = lazy(() => import("@/pages/pageNotFound.tsx"));

function Routing({user}: { user: User }) {

    const contextVal = useMemo(() => {
        return {
            user,
            l: user.language
        }
    }, [user])
    return (
        <RootContext.Provider value={contextVal}>
            <BrowserRouter>
                <Routes>
                    <Route path="/backoffice" Component={Backoffice}>
                        <Route path="/backoffice/users" Component={UserManagement}/>
                        <Route path="/backoffice/users/:userId" Component={UserManagement}/>
                        <Route path="/backoffice/units" Component={DryingUnitManagement}/>
                        <Route path="/backoffice/units/:unitId" Component={DryingUnitManagement}/>
                    </Route>
                    <Route path="/" Component={Layout}>
                        <Route path="/" Component={Overview}/>
                        <Route path="/control" Component={Control}/>
                        <Route path="/stats" Component={Statistics}/>
                    </Route>
                    <Route path="/alarm-history/:unitId" Component={AlarmHistory}/>
                    <Route path="*" Component={PageNotFound}/>
                </Routes>
            </BrowserRouter>
        </RootContext.Provider>
    )
}

export default Routing;
